import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45a7f9d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "withholding-corporation px-3 py-4" }
const _hoisted_2 = {
  key: 0,
  class: "withholding-list bg-white border border-outline-color px-3 mt-3 round-4"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "text-black text-size-14 text-weight-500" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14 text-center mt-3" }, "\n          勤務完了したお仕事がありません\n        ", -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _ctx.onBack
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      源泉徴収票の発行\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.slipList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slipList, (slip) => {
              return (_openBlock(), _createElementBlock("div", {
                key: slip.id,
                class: "withholding-item"
              }, [
                _createElementVNode("a", {
                  target: "_blank",
                  role: "button",
                  class: "d-flex justify-content-between align-items-center py-3",
                  onClick: ($event: any) => (_ctx.downloadPdf(slip))
                }, [
                  _createElementVNode("p", _hoisted_4, _toDisplayString(slip.name), 1),
                  _createTextVNode(),
                  _createVNode(_component_FeatherIcon, {
                    icon: "chevron-right",
                    class: "text-gray-05"
                  })
                ], 8, _hoisted_3)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
    ])
  ]))
}